import { OptionProps } from 'components_new/molecules/OptionsMenu'
import { TFunction } from 'language/translator'

import {
  MetricCalculationBlockType,
  MetricCalculationOperation
} from 'types/GlobalMetric'

export const operators: MetricCalculationOperation[] = [
  MetricCalculationOperation['PLUS'],
  MetricCalculationOperation['MINUS'],
  MetricCalculationOperation['MULTIPLICATION'],
  MetricCalculationOperation['DIVISION']
]

export const translateOperator: Record<
  MetricCalculationOperation,
  string
> = {
  [MetricCalculationOperation.PLUS]: '+',
  [MetricCalculationOperation.MINUS]: '–',
  [MetricCalculationOperation.MULTIPLICATION]: '×',
  [MetricCalculationOperation.DIVISION]: '÷'
}

export const getOptions = (
  editType: (value: MetricCalculationBlockType) => void,
  t: TFunction
): OptionProps[] => {
  return [
    {
      iconName: 'NumbersOutlined',
      onClick: () => editType(MetricCalculationBlockType.NUMBER),
      title: t('accounting', 'constant')
    },
    {
      iconName: 'TrendingUpOutlined',
      onClick: () => editType(MetricCalculationBlockType.TEMPLATE),
      title: t('metrics', 'metric')
    },
    {
      iconName: 'ViewCarouselOutlined',
      onClick: () => editType(MetricCalculationBlockType.BLOCK),
      title: t('accounting', 'calculation_block')
    },
    {
      iconName: 'SellOutlined',
      onClick: () => editType(MetricCalculationBlockType.VARIABLE),
      title: t('accounting', 'account_level')
    }
  ]
}
